import { getInitials } from "@upsquad/shared";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "@/src/common/components/ui";

const TESTIMONIAL_KEYS = [
	{ quoteKey: "testimonial_1_quote", nameKey: "testimonial_1_name", roleKey: "testimonial_1_role" },
	{ quoteKey: "testimonial_2_quote", nameKey: "testimonial_2_name", roleKey: "testimonial_2_role" },
] as const;

export function TestimonialsCarousel() {
	const { t } = useTranslation("common");
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setActiveIndex((prev) => (prev + 1) % TESTIMONIAL_KEYS.length);
		}, 6000);
		return () => clearInterval(interval);
	}, []);

	const activeTestimonial = TESTIMONIAL_KEYS[activeIndex] ?? TESTIMONIAL_KEYS[0];
	const translatedName = t(activeTestimonial.nameKey);

	return (
		<div className="flex flex-col justify-end h-full text-white">
			<div className="flex gap-1.5 mb-8">
				{TESTIMONIAL_KEYS.map((_, i) => (
					<button
						type="button"
						key={i}
						onClick={() => setActiveIndex(i)}
						className={`w-2.5 h-2.5 rounded-full transition-colors ${i === activeIndex ? "bg-white" : "bg-white/40"}`}
						aria-label={`Testimonial ${i + 1}`}
					/>
				))}
			</div>
			<div className="min-h-[180px]">
				<blockquote className="text-3xl font-semibold leading-tight mb-8">{t(activeTestimonial.quoteKey)}</blockquote>
				<div className="flex items-center gap-3">
					<Avatar size="sm">
						<Avatar.Fallback>{getInitials(translatedName)}</Avatar.Fallback>
					</Avatar>
					<div>
						<p className="font-medium text-sm">{translatedName}</p>
						<p className="text-sm text-white/70">{t(activeTestimonial.roleKey)}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
